import { AppForms, I18N, React } from '@/app'
import { useCallback, useForm } from '@codeleap/common'
import { Text, TextInput, View } from '@/components'
import { onOpenCommunityGuidelines } from '@/utils'

type UseCommunityFormParams = {
  prompt?: boolean
  initialState?: AppForms.CommunityFormValue
  required?: boolean
  isFile?: boolean
}

export const useContributeForm = (params: UseCommunityFormParams) => {
  const { initialState, prompt, required, isFile = false } = params

  const getForm = useCallback(() => AppForms.communityPostForm(prompt, required, isFile), [prompt, required, isFile])

  return useForm(getForm, { initialState, validateOn: 'change' })
}

export type ContributeFormProps = React.PropsWithChildren<{
  form: ReturnType<typeof useContributeForm>
  prompt?: boolean
  title?: string
  showGuidelines?: boolean
  isFile?: boolean
}>

export const ContributeForm = (props: ContributeFormProps) => {
  const { children, form, prompt = false, title, showGuidelines = true, isFile = false } = props
  const contributionType = isFile ? 'post' : 'text'

  return (
    <>
      <View variants={['column', 'marginBottom:3', 'gap:2']}>
        <Text text={title ?? 'Contribute with...'} variants={['h2', 'bold']} />
        {!isFile && <Text text='Contribute with some text that will help the Hurd community' variants={['p1']} />}
        {showGuidelines ? (
          <Text variants={['p1']}>
            {`The ${contributionType} will be publicly displayed, and must meet the `}
            <Text
              component={p => <span {...p} />}
              variants={['p1', 'underline', 'bold', 'color:primary3', 'cursor:pointer']}
              onPress={onOpenCommunityGuidelines}
              text={I18N.t('communityGuidelines')}
            />
          </Text>
        ) : null}
      </View>

      <View variants={['column']}>
        {prompt ? null : <TextInput {...form.register('title')} />}
        {isFile && prompt ? null : <TextInput {...form.register('description')} label={'Description'} />}
      </View>

      {children}
    </>
  )
}
